import React from 'react'
import "../featured_products/FeaturedProducts.css"
import ReusableFeaturedProducts from '../organic1-reusable/ReusableFeaturedProducts'
import { Container, Row } from 'react-bootstrap'

const FeaturedProducts = () => {
  return (
    <>
        <section id="featured_products">
          <Container>
            <h1>Featured Products </h1>
            <Row className='pt-5' style={{rowGap:'40px'}}>
              <ReusableFeaturedProducts img="imeges/desktop1/Featured Products-strowbarry.png"/>
              <ReusableFeaturedProducts img="imeges/desktop1/Featured Products-avocado.png"/>
              <ReusableFeaturedProducts img="imeges/desktop1/Featured Products-licu.png"/>
            </Row>
          </Container>
  </section>

    </>
  )
}

export default FeaturedProducts